import { Component, OnInit, Inject } from '@angular/core';
import { TemperatureInspectionService } from '../temperature-inspection.service';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-temp-inspection-details-comment',
  templateUrl: './add-temp-inspection-details-comment.component.html',
  styleUrls: ['./add-temp-inspection-details-comment.component.scss']
})
export class AddTempInspectionDetailsCommentComponent implements OnInit {

  inspectionDetailID:number;
  comment: string;
  savingComment = false;
  isInspector = false;
  isInterpreter = false;
  newComment= '';
  isedit:boolean;
  constructor(
    public _dialogRef: MatDialogRef<AddTempInspectionDetailsCommentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private _notify: NotificationsService,
    private  _temperatureService: TemperatureInspectionService,
  ) { }

  ngOnInit() {
    this.inspectionDetailID = this.data.inspectionDetailID;
    this.newComment = this.data.Inspcomment;
    this.isedit=this.data.isedit;
  }

  success(title: string, message: string) {
    this._notify.success(title, message);
    this._dialogRef.close(true);
    this.savingComment = false;
  }

  error(title: string, message: string, err: any) {
    this._notify.error(title, message);
    console.error(err);
    this.savingComment = false;
  }
  updateComment(){
    this._temperatureService.updateInspectionDetailComment(this.inspectionDetailID, this.newComment ).subscribe(r => {
      if (r.m_Item1) {
        this.success('Saved', r.m_Item2);
      } else {
        this.error('Failed', r.m_Item2, r.m_Item2);
      }
    }, err => {
      this.error('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
    });
  }

}
